<div class="native-session">
  <img src="assets/images/logoBanka.png" alt="Bakna" class="native-session__logo" />
  <div class="spinner-border text-primary" role="status">
    <span class="visually-hidden">Cargando…</span>
  </div>
  <p class="native-session__text">Restaurando tu sesión…</p>
</div>
